import React, { useContext, useMemo } from "react";
import "./pos.css";
import { useParams } from "react-router-dom";
import { FaCreativeCommonsNc } from "react-icons/fa";
import { useGeneralHooks } from "../../../../../hooks/generalHooks";

//functions
import {
  _t,
  currencySymbolLeft,
  currencySymbolRight,
  checkPermission,
  debouncePromise,
  // restaurantMenuLink,
} from "../../../../../functions/Functions";
import { UserContext } from "../../../../../contexts/User";
import { useCustomHooks } from "../../../../../functions/Hooks";

const suggestQty = [100,125,250,375,500,750,875,1000]

const CartItem = ({
  itemId,
  item,
  deleteItem,
  editItem,
  getPrice,
  addToCart,
  deleteOneCartItem,
  deletedItemsOnEdit,
  setAddReasonModalShowing,
  orderDetails,
  itemAdd,
  isLocked,
  authenticateStaffUser,
  isOpenQty,
  setAddFocItem,
  handleSetItemQty,
  handleSetItemPrice,
  handleSetItemDiscount,
  setCommentId,
  animate,
}) => {
  //edit order
  const { order_id } = useParams();
  const { itemWiseDiscount } = useGeneralHooks();
  const { roundOffPrice } = useCustomHooks();
  const { authUserInfo } = useContext(UserContext);

  const debouncedPriceChange = React.useCallback(
    debouncePromise((item, itemId, value) => {
      handleSetItemPrice(item, itemId, value);
    }, 700),
    [handleSetItemPrice]
  );
  
  const itemProperty = [];
  if (parseInt(item.item.has_property) === 1 && Object.keys(item.properties)?.length > 0) {
    Object.values(item.properties).forEach((item) => {
      const properties = Object.values(item);
      properties.forEach((property) => {
        const propertyName = property.item.name;
        itemProperty.push(
          <span className="item_property" key={propertyName}>
            {property.quantity} - {propertyName}
          </span>
        );
      });
    });
  }

  const checkKdsPermission = useMemo(()=>{
    return authUserInfo?.permissions && checkPermission(authUserInfo.permissions, "Kitchen")
  }, [authUserInfo.permissions])
 
  return (
    <div key={itemId} id={itemId ? "cart_Item" : ""}  className={`d-flex align-items-center border-bottom position-relative pos--cart-item ml-1 py-1
    ${isOpenQty? 'pr-0':" not-open-qty"} ${order_id &&!item.new && !itemAdd?.[itemId] && !deletedItemsOnEdit?.[itemId] ? "pos-cart-bg" : ""}`}
    style={{ position: isOpenQty ? "relative" : "unset" }}
    >
      <div className="text-capitalize position-relative item_variation font-weight-md col-4">
        {item.item.name}
        {parseInt(item.item.has_variation) === 1 ? (
          <span className="item_variation ml-1 text-primary">
            ({item?.variation?.variation_name}){" "}
          </span>
        ) : (
          <></>
        )}
        {Number(item.item_discount) > 0 && <span className="discount-icon">⭐</span>}
        <br />
        {parseInt(item.item.has_property) === 1 && itemProperty}
      </div>

      <div className="text-capitalize position-relative item_variation col-3 text-center counter-qty">
        {item.quantity > 1 ? (
          <button
            disabled = {orderDetails.is_split || (order_id && !item.new && isLocked("item_remove_qty_cp"))}
            className="mx-1 itemQtyBtn cart-decrement"
            onClick={() => {
              animate.current = "del";
              if((item.status === "foc" || item.status === "complimentory") || (item.offer_type === "bogo" && item.item_discount > 0)){
                  
              }else{
                if (order_id) {
                  const checkStatus = deletedItemsOnEdit && deletedItemsOnEdit[itemId] && deletedItemsOnEdit[itemId]?.status === "made" ? true : false;
                  item.new === true ||
                  (deletedItemsOnEdit && deletedItemsOnEdit[itemId]?.status) ||
                  (itemAdd && itemAdd[itemId] && itemAdd[itemId] !== undefined)
                    ? deleteOneCartItem(itemId, checkStatus)
                    : setAddReasonModalShowing({
                        action: "decrease",
                        params: [itemId],
                      });
                } else {
                  deleteOneCartItem(itemId);
                }
              }
            }}
          >
            <i className="fa fa-minus"></i>
          </button>
        ) : (
          <button className="mx-1 itemQtyBtn cart-decrement">
            <i className="fa fa-minus"></i>
          </button>
        )}
        {
          isOpenQty ? (
            <>
              <input type="number" disabled={(item.status === "foc" || item.status === "complimentory") || (order_id && item.new === false) || (item.offer_type === "bogo" && item.item_discount > 0)} style={{width:"47%",minHeight:"1.4rem",textAlign:"center"}}
               className="form-control cartInputQty rounded-25 d-inline-block px-0" value={item.quantity} onChange={(e)=>handleSetItemQty(item,itemId,parseInt(e.target.value))} />

              {
                (order_id && item.new === false) || (item.offer_type === "bogo" && item.item_discount > 0) ? (
                ""
                ) : (
                  <div className="qty_suggestion">
                    {
                      suggestQty.map((qty) => (
                        <div
                          key={qty}
                          className={`mx-1 mb-1 ${qty === item.quantity? "active" : ""}`}
                          onClick={() => handleSetItemQty(item, itemId, qty)}
                        >
                          {qty}
                        </div>
                      ))
                    }
                  </div>
                )
              }
            </>
          ) : (
            item.quantity
          )
        }
        
        <button
          disabled = {orderDetails.is_split || (order_id && checkKdsPermission && !item.new) || (order_id && (!item.new ? isLocked("item_remove_qty_cp") : ""))}
          className="mx-1 itemQtyBtn cart-increment"
          onClick={() =>{
            animate.current = "add";
            if((item.status === "foc" || item.status === "complimentory") || (item.offer_type === "bogo" && item.item_discount > 0)){
            }else{
              addToCart(itemId, item)
            }
          }}
        >
          <i className="fa fa-plus"></i>
        </button>
      </div>

      <div className="col-1 text-center">
        <input
          type="number"
          disabled={(!itemWiseDiscount && !orderDetails.branch?.item_wise_discount) || 
            (item.status === "foc" || item.status === "complimentory") || orderDetails.scheme?.scheme_id}
          className="form-control cartInputQty text-center p-1 rounded-25"
          style={{minHeight:"1.4rem"}}
          onKeyDown={(evt) =>
            ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
            evt.preventDefault()
          }
          max={100}
          value={item?.discount || ""}
          onWheel={(e) => e.target.blur()}
          onChange={(e)=>handleSetItemDiscount(itemId, e.target.value)}
        />
      </div>
      <div className="col-1 sm-text font-weight-md text-center"
        style={{padding: "0 1px"}}
      >
        {item?.item_discount ?? ""}
      </div>

      <div
        className="text-capitalize item_variation font-weight-bold col-3 text-right text-break pl-1"
        style={{ position: isOpenQty ? "unset" : "relative" }}
      >
        {
          <span className={`${isOpenQty ? "isisOpenQty--span" : ""}`}>
            {isOpenQty && item.item.has_variation === "0" && item.item.has_property === "0" ?
              <>
               {item.item_discount > 0 && orderDetails.scheme?.cap_amount <= 0 ? (
                  <>
                    <span style={{color:"#e43b53", marginRight:"2px"}}>
                      {roundOffPrice(getPrice(item) - item.item_discount)}
                    </span>
                    <del>{getPrice(item)}</del>
                  </>  
                ) : currencySymbolLeft() + getPrice(item)}
                {
                  !(order_id && item.new === false) && (
                    <input
                      disabled={orderDetails.is_split || (item.status === "foc" || item.status === "complimentory") || (order_id && item.new === false) || (item.offer_type === "bogo" && item.item_discount > 0)}
                      type="number"
                      className="form-control cartInputQty rounded-25 d-inline-block px-1"
                      // value={getPrice(item)}
                      onChange={(e) => debouncedPriceChange(item,itemId,(e.target.value))}
                      style={{
                        border: "none",
                        background: "transparent",
                      }}
                    />
                  )
                }
              </>
              : (
                <>
                  {item.item_discount > 0 && orderDetails.scheme?.cap_amount <= 0 ? (
                    <>
                      <span style={{color:"#e43b53", marginRight:"3px"}}>
                        {currencySymbolLeft()}
                        {roundOffPrice(getPrice(item) - item.item_discount)}
                        {currencySymbolRight()}
                      </span>
                      <del>{getPrice(item)}</del>
                    </>
                  ) : currencySymbolLeft() + getPrice(item)}
                </>
              )}
            
          </span>
        }
      
        <div
          className="position-absolute left-0 bottom-0 justify-content-end align-items-center pos--cart-actions-menu"
          style={{ background: "white" }}
        >
          <button 
            title={"info"}
            onClick={(e) => {
              if (item && item !== undefined) {
                setCommentId(itemId);
              }
            }}
            className="badge badge-secondary btn-info item_comment_icon"
          >
            <i className="fa fa-info" aria-hidden="true"></i>
          </button>
          {(item.status === "foc" || item.status === "complimentory") ? "" :
            ((parseInt(item.item.has_property) === 1 || parseInt(item.item.has_variation) === 1) &&
            ((order_id && item.new) || !order_id) && (
              <button onClick={() => editItem(itemId)} title="edit" className="item_edit_icon">
                <i className="fa fa-pencil"></i>
              </button>
            ))
          }
          {authUserInfo?.permissions && checkPermission(authUserInfo.permissions, "Item Foc") ? (
            isLocked("item_foc") ? (
              <span
                className="pointer-cursor ml-2 mr-1 d-flex align-items-center"
                onClick={(e) => authenticateStaffUser("item_foc")}
              >
                <i className="fa fa-lock lock_icon"></i>
              </span>
            ) : (item.status === "foc" || item.status === "complimentory") ? "" : (
              <button
                className="item_edit_icon"
                title="foc"
                onClick={() => {
                  animate.current = false;
                  setAddFocItem({
                    modal: true,
                    itemId: itemId,
                    reason: ""
                  })
                }}
              >
                <FaCreativeCommonsNc/>
              </button>
            )) : ""
          }
          {order_id && (item.new !== true) &&
            isLocked("item_remove_qty_cp") ? (
            <span
              className="pointer-cursor ml-2 mr-1 d-flex align-items-center"
              onClick={(e) => authenticateStaffUser("item_remove_qty_cp")}
            >
              <i className="fa fa-lock lock_icon"></i>
            </span>
          ) : (
            <>
              <button
                className="item_delete_icon"
                title="delete"
                disabled={orderDetails.is_split}
                onClick={() => {
                  animate.current = false;
                  if (order_id) {
                    const checkStatus = deletedItemsOnEdit && deletedItemsOnEdit[itemId] && deletedItemsOnEdit[itemId]?.status === "made" ? true : false;
                    (item.new === true || (deletedItemsOnEdit && deletedItemsOnEdit[itemId]?.status))
                      ? deleteItem(itemId, checkStatus)
                      : setAddReasonModalShowing({
                        action: "remove",
                        params: [itemId],
                      });
                  } else {
                    deleteItem(itemId);
                  }
                }}
              >
                <i className="fa fa-trash"></i>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItem;

